import { useMemo } from 'react';
import type { LegacyMilestone } from '../data/legacyMilestones';
import type { StoryPhoto } from '../components/StoryGallery';

type TimelineYear = {
  year: string | number;
  photoCount?: number;
  isActive?: boolean;
  activePhotoIndex?: number;
};

export const useTimelineYears = (
  milestones: LegacyMilestone[],
  activeYear: string,
  activePhotoIndex: number
): TimelineYear[] => {
  return useMemo(() => {
    return [...milestones]
      .map((milestone) => ({
        year: milestone.year,
        photoCount: ((milestone.photos as StoryPhoto[]) ?? []).length,
        isActive: milestone.year === activeYear,
        activePhotoIndex: milestone.year === activeYear ? activePhotoIndex : undefined,
      }))
      .sort((a, b) => Number(a.year) - Number(b.year));
  }, [milestones, activeYear, activePhotoIndex]);
};
